import Swiper, { SwiperSlide } from "../../components/swiper";
import { useFetchData } from "../../helpers/api";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import CategoryItem from "../../pages/category/CategoryItem";

const settings = {
  loop: false,
  grabCursor: true,
  observer: true,
  observeParents: true,
  spaceBetween: 30,
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
};

const MostViewedProducts = () => {
  const { data: homeMostViewedProducts, isLoading } = useFetchData(
    ["homeMostViewedProducts"],
    "/Customer/GetMostViewedProduct",
    {}
  );

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <section className="home_product_slider most_viewed">
        <h4 className="heading_with_line center_aligned">
          MOST VIEWED PRODUCTS
        </h4>
        <div className="container">
          <Swiper options={settings}>
            {homeMostViewedProducts?.Data.map((product) => (
              <SwiperSlide key={product.StyleId}>
                <CategoryItem product={product} showSizes="false" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default MostViewedProducts;
